import axios from 'axios';
import useSWR from 'swr';

import { getApiUrl } from '@/helpers/api';

export const usePostCoachActivity = () => {
  const postCoachActivity = async (payload) => {
    try {
      const url = `${getApiUrl()}/coach-activity`;
      const response = await axios.post(url, payload);
      return response.data;
    } catch (err) {
      throw Error(err.response.data.message);
    }
  };

  return postCoachActivity;
};

export const usePutCoachActivity = () => {
  const putCoachActivity = async (id, payload) => {
    try {
      const url = `${getApiUrl()}/coach-activity/${id}`;
      const response = await axios.put(url, payload);
      return response.data;
    } catch (err) {
      throw Error(err.response.data.message);
    }
  };

  return putCoachActivity;
};

export const useCoachActivityAcceptTerms = () => {
  const coachActivityAcceptTerms = async (id, payload) => {
    try {
      const url = `${getApiUrl()}/coach-activity/${id}/accept-terms`;
      const response = await axios.put(url, payload);
      return response.data;
    } catch (err) {
      throw Error(err.response.data.message);
    }
  };

  return coachActivityAcceptTerms;
};

export const useCoachActivityResubmitApplication = () => {
  const coachActivityResubmitApplication = async (id) => {
    try {
      const url = `${getApiUrl()}/coach-activity/${id}/resubmit-application`;
      const response = await axios.put(url);
      return response.data;
    } catch (err) {
      throw Error(
        err.response?.data?.message ||
          'An error occurred while resubmitting the application'
      );
    }
  };

  return coachActivityResubmitApplication;
};

export const useCoachActivity = (coachActivityId) => {
  const urlStr = coachActivityId
    ? `${getApiUrl()}/coach-activity/${coachActivityId}`
    : null;

  const swr = useSWR(
    urlStr,
    async (url) => {
      try {
        const result = await axios.get(url);
        return result.data;
      } catch (err) {
        throw Error(err);
      }
    },
    {
      dedupingInterval: 30000, // 30 seconds
      revalidateOnFocus: false,
      revalidateOnReconnect: false
    }
  );
  return swr;
};

export const useCoachActivities = () => {
  const urlStr = `${getApiUrl()}/coach-activity`;
  const swr = useSWR(urlStr, async (url) => {
    try {
      const result = await axios.get(url);
      return result.data;
    } catch (err) {
      throw Error(err);
    }
  });
  return swr;
};

export const listCoachActivitiesInline = async () => {
  const urlStr = `${getApiUrl()}/coach-activity`;
  try {
    const result = await axios.get(urlStr);
    return result.data;
  } catch (err) {
    throw Error(err);
  }
};

export const useCoachActivityStats = () => {
  const urlStr = `${getApiUrl()}/coach-activity/self/stats`;
  const swr = useSWR(
    urlStr,
    async (url) => {
      try {
        const result = await axios.get(url);
        return result.data;
      } catch (err) {
        throw Error(err);
      }
    },
    {
      dedupingInterval: 30000, // 30 seconds
      revalidateOnFocus: false,
      revalidateOnReconnect: false
    }
  );
  return swr;
};

export const useCoachActivityContract = (coachActivityId) => {
  const urlStr = `${getApiUrl()}/coach-activity/${coachActivityId}/contract`;
  const swr = useSWR(
    urlStr,
    async (url) => {
      try {
        const result = await axios.get(url);
        return result.data;
      } catch (err) {
        throw Error(err);
      }
    },
    {
      dedupingInterval: 30000, // 30 seconds
      revalidateOnFocus: false,
      revalidateOnReconnect: false
    }
  );
  return swr;
};

export const useSubmitApplication = () => {
  const submitApplication = async (coachActivityId) => {
    try {
      const url = `${getApiUrl()}/coach-activity/${coachActivityId}/submit-application`;
      const response = await axios.put(url);
      return response.data;
    } catch (err) {
      throw Error(
        err.response?.data?.message ||
          'An error occurred while submitting the application'
      );
    }
  };

  return submitApplication;
};
